var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.4,
    height: 26.4,
    transform: "translate(12 12)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3263 15H34.6998L27.3297 23.4235L36 34.886H29.2112L23.894 27.934L17.8099 34.886H14.4344L22.3174 25.8761L14 15H20.9611L25.7674 21.3543L31.3263 15ZM30.1423 32.8668H32.0116L19.9454 16.9131H17.9395L30.1423 32.8668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIconFilled);
export default __webpack_public_path__ + "static/media/twitterIconFilled.cbad0aceaabdabf32415700746dbc6ba.svg";
export { ForwardRef as ReactComponent };